export const SET_SHOW_MOBILE_MENU = 'SET_SHOW_MOBILE_MENU';
export const GET_SHOW_MOBILE_MENU = 'GET_SHOW_MOBILE_MENU';
